import {LOADING, PUT_META, PUT_VIDEO_HISTORY} from './actions'

const initialState = {
    loading: false,
    videoHistory: []
}

const reducer = (state = initialState, { type, payload }) => {
    switch(type) {

        case LOADING:
            return {
                ...state,
                loading: payload
            }

        case PUT_VIDEO_HISTORY:
            return {
                ...state,
                loading: false,
                videoHistory: payload,
            }
    }
    return state
}

export default reducer